<template>
  <nut-form-item
    :prop="prop"
    :rules="rules"
    :label="label"
    :required="props.required"
    :label-width="labelWidth"
  >
    <nut-input
      v-model="text"
      :placeholder="props.placeholder"
      readonly
      @click="disabled === false ? (visible = true) : null"
      :disabled="disabled"
    >
      <template #right v-if="!props.disabled">
        <ArrowRight color="#969799" />
      </template>
    </nut-input>
    <nut-popup v-model:visible="visible" position="bottom">
      <div v-if="multiple">
        <div class="nut-picker__bar">
          <div class="nut-picker__left" @click="visible = false">取消</div>
          <div class="nut-picker__title">{{ label }}</div>
          <div class="nut-picker__right" @click="confirm">确定</div>
        </div>
        <nut-checkbox-group v-model="multipleValues">
          <nut-checkbox :label="item.value" v-for="item in props.list" :key="item.value">{{
            item.text
          }}</nut-checkbox>
        </nut-checkbox-group>
      </div>
      <nut-date-picker
        v-else-if="props.time"
        v-model="val"
        :three-dimensional="false"
        :title="label"
        :type="props.timeType"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="visible = false"
        @confirm="confirm"
      ></nut-date-picker>
      <nut-picker
        v-else
        v-model="selectedOption"
        :columns="props.list"
        :title="label"
        @cancel="visible = false"
        @confirm="confirm"
      />
    </nut-popup>
  </nut-form-item>
</template>

<script setup>
import cloneDeep from 'lodash/cloneDeep'
import { ArrowRight } from '@nutui/icons-vue'
import dayjs from 'dayjs'

const emit = defineEmits(['update:modelValue', 'change'])

const props = defineProps({
  multiple: {
    type: Boolean,
    default: false
  },
  rules: {
    type: Array
  },
  prop: {
    type: String
  },
  minDate: {
    type: Date,
    default: dayjs().subtract(10, 'year').toDate()
  },
  maxDate: {
    type: Date,
    default: dayjs().add(10, 'year').toDate()
  },
  labelWidth: {
    type: String
  },
  modelValue: {
    type: String || Array,
    require: true
  },
  list: {
    type: Array,
    default: []
  },
  disabled: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  },
  time: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    require: true
  },
  placeholder: {
    type: String,
    default: '请选择'
  },
  title: {
    type: String,
    default: '请选择'
  },
  timeType: {
    type: String,
    default: 'date'
  }
})
const visible = ref(false)
const val = ref()
const timeShow = ref()

const multipleValues = ref([])

watch(
  () => props.modelValue,
  (value) => {
    console.log(value, 'modelValue')

    if (props.time) {
      timeShow.value = value
      val.value = new Date(value)
    }
  },
  { immediate: true }
)

const text = computed(() => {
  if (props.multiple) {
    return props.list
      .filter((a) => props.modelValue.includes(a.value))
      .map((a) => a.text)
      .join(',')
  }
  if (props.time) {
    if (props.timeType === 'date') {
      if (props.modelValue) {
        return dayjs(props.modelValue).format('DD-MM-YYYY')
      } else if (timeShow.value) {
        return dayjs(timeShow.value).format('DD-MM-YYYY')
      } else {
        return ''
      }
    }
    if(props.timeType === 'datetime') {
      if (props.modelValue) {
        return dayjs(props.modelValue).format('DD-MM-YYYY HH:mm')
      } else if (timeShow.value) {
        return dayjs(timeShow.value).format('DD-MM-YYYY HH:mm')
      } else {
        return ''
      }
    }
  }
  return props.list.find((item) => item.value === props.modelValue)?.text
})

const selectedOption = computed(() => {
  if (!props.modelValue) return []
  const opt = props.list.find((item) => item.value === props.modelValue)?.value
  return [opt]
})

function confirm(e) {
  if (props.multiple) {
    emit('update:modelValue', cloneDeep(multipleValues.value))
    visible.value = false
    return
  }
  if (props.time) {
    const obj = e.selectedValue
    let value = obj[0] + '-' + obj[1] + '-' + obj[2]
    timeShow.value = value
    if (dayjs(timeShow.value).isAfter(dayjs(props.maxDate))) {
      timeShow.value = dayjs(props.maxDate).format('YYYY-MM-DD')
      value = dayjs(props.maxDate).format('YYYY-MM-DD')
    }
    emit('update:modelValue', value)
  } else {
    const obj = e.selectedOptions[0]
    val.value = obj.value
    emit('update:modelValue', obj.value)
  }
  visible.value = false
  emit('change', e)
}
</script>

<style lang="scss" scoped>
:deep .nut-checkbox-group {
  padding: 0 16px;
  .nut-checkbox {
    display: block;
    padding: 10px 20px;
    border-bottom: 1px solid #ebedf0;
    margin-right: 0;
  }
}
</style>
